document.addEventListener('DOMContentLoaded', function () {
    if (window.customer) {
        const loyaltyEndpoint = 'https://www.kasaustralia.com.au/apps/datajet/task/67bfe67e4e4cd457d0463ed2';
        // fetch with body data 
        fetch(loyaltyEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: window.customer.email,
            })
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            if (data && data.data.ok) {
                const customerData = data.data.body;
                const pointBalance = customerData.points_balance;
                const emails = document.querySelectorAll('.c-account-dropdown__loyalty-email');
                const points = document.querySelectorAll('.c-account-dropdown__loyalty__points');
                const greetings = document.querySelectorAll('.c-account-dropdown__greeting');
                const loyaltyRembembered = document.querySelectorAll('.c-account-dropdown__loyalty-remember');
                const pointAwards = document.querySelectorAll('.c-account-dropdown__loyalty__text');


                points.forEach(function (element) {
                    element.textContent = pointBalance + ' points';
                });

                pointAwards.forEach(function (element) {
                    const pointReachDiscount = 100 - (pointBalance % 100);
                    const reachDiscount = Math.ceil(pointBalance / 100);
                    
                    element.querySelector('p').textContent = `You are ${pointReachDiscount} points away from a $${reachDiscount * 10} discount`;
                    
                });
                

                if (window.customerRemembered) {
                    emails.forEach(function (element) {
                        element.textContent = window.customer.email;
                    });

                    greetings.forEach(function (element) {
                        element.textContent = `Hi, ${window.customer.firstName} ${window.customer.lastName}`;
                    });

                    loyaltyRembembered.forEach(function (element) {
                        element.classList.remove('hidden');
                    });
                }
            }
        });
    } else {
        document.querySelectorAll('.c-account-dropdown__loyalty.hidden').forEach(function (element) {
            element.classList.remove('hidden');
        });
    }
});